// extracted by mini-css-extract-plugin
module.exports = {"buttonStyle":"Link_buttonStyle__1qEOd Button_button__8HElB","wrapper":"Link_wrapper__2poOF","disabled":"Link_disabled__2zFGz","icon":"Link_icon__jeQRc","arrow":"Link_arrow__EJmEZ"};